module.exports = __webpack_public_path__ + "static/media/spjc_logo.179adffa.gif";